// src/pages/Sensor/MissingMeasurements.tsx

import { MemoryTwoTone } from '@mui/icons-material'
import { Avatar, List, ListItem, ListItemText, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'

import { SensorId } from '@/types/domain'

import { userLocales } from '../../api'
import { KPage, Preloader } from '../../components'
import { useMissingData } from '../../hooks'

const getDayList = from => {
  const fromDate = new Date(from)
  const toDate = new Date()
  const days = Math.ceil(
    (toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)
  )

  return Array.from({ length: days + 1 }, (_, key) => {
    const date = new Date(fromDate)
    date.setDate(fromDate.getDate() + key)

    return date
  })
}

export const MissingMeasurements = () => {
  const { id } = useParams()
  const sId: SensorId = Number(id)
  const { data, isLoading } = useMissingData(sId)

  const missing = data
    // filter records not intended to be days related
    ?.filter(f => f.days !== null)
    // YYYY-MM-DD
    ?.map(item => String(`${item.years}-${item.months}-${item.days}`))

  const dayList = getDayList(missing?.[0])
    .filter(
      f => !missing?.some(item => new Date(item).getTime() === f.getTime())
    )
    .reverse()

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    weekday: 'short',
  }

  const firstRecord = new Date(missing?.[0]).toLocaleString(
    userLocales,
    options
  )

  return (
    <>
      {/* preloader */}
      <Preloader isLoading={isLoading} />
      {/* preloader end */}

      {!isLoading && (
        <KPage
          avatar={
            <Avatar>
              <MemoryTwoTone />
            </Avatar>
          }
          title={`Fehlende Messtage Sensor ID: ${sId}`}
        >
          <Typography>
            Seit Beginn, <strong>{firstRecord}</strong>, fehlen{' '}
            <strong>{dayList.length}</strong> Einträge.
          </Typography>

          <Typography>
            An folgenden Tagen hat Sensor ID {sId} nicht gesendet:
          </Typography>

          <List sx={{ maxHeight: 300, overflow: 'auto' }}>
            {dayList.map(day => (
              <ListItem key={day.toISOString()}>
                <ListItemText>
                  {day.toLocaleString(userLocales, options)}
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </KPage>
      )}
    </>
  )
}
